// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1VcmN","dragIcon":"Choice_dragIcon__iJOsg","left":"Choice_left__16v_q","input":"Choice_input__3syTB"};